import { render, staticRenderFns } from "./BmLogin.vue?vue&type=template&id=6d15c00f&scoped=true&"
import script from "./BmLogin.vue?vue&type=script&lang=js&"
export * from "./BmLogin.vue?vue&type=script&lang=js&"
import style0 from "./BmLogin.vue?vue&type=style&index=0&id=6d15c00f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d15c00f",
  null
  
)

export default component.exports